/*---------------------------------------------------------------------------------------------
 *  Copyright (c) Microsoft Corporation. All rights reserved.
 *  Licensed under the MIT License. See License.txt in the project root for license information.
 *--------------------------------------------------------------------------------------------*/

import * as React from 'react';

import { ILiquidLocatorData } from './liquid-locator.data';
import { ILiquidLocatorProps } from './liquid-locator.props.autogenerated';

export interface ILiquidLocatorViewProps extends ILiquidLocatorProps<ILiquidLocatorData> {
    obIframe: string;
}

/**
 *
 * LiquidLocator component
 * @extends {React.PureComponent<ILiquidLocatorProps<ILiquidLocatorData>>}
 */
class LiquidLocator extends React.PureComponent<ILiquidLocatorProps<ILiquidLocatorData>> {
    public render(): JSX.Element | null {
        const { config } = this.props;

        const ObIframe = config.obIframe ? config.obIframe : 'No Iframe Provided';
        const LiquidLocatorViewProps = {
            ...this.props,
            obIframe: ObIframe,
        };
        return this.props.renderView(LiquidLocatorViewProps);
    }
}

export default LiquidLocator;
